import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchTechVisitForms(serviceProviderId) {
    return RequesterV1.get(
      `service_provider/tech_visits/reporting/home/${serviceProviderId}/fetch_tech_visit_forms`
    );
  },

  fetchCropFields(serviceProviderId) {
    return RequesterV1.get(
      `service_provider/tech_visits/reporting/home/${serviceProviderId}/fetch_crop_fields`
    );
  },

  downloadReportDetailed(serviceProviderId, filters) {
    const urlQueryParams = new URLSearchParams(filters);
    return RequesterV1.get(
      `service_provider/tech_visits/reporting/home/${serviceProviderId}/download_report_detailed?${urlQueryParams}`,
      { responseType: "blob" }
    );
  },

  downloadReportRelevants(serviceProviderId, filters) {
    const urlQueryParams = new URLSearchParams(filters);
    return RequesterV1.get(
      `service_provider/tech_visits/reporting/home/${serviceProviderId}/download_report_relevants?${urlQueryParams}`,
      { responseType: "blob" }
    );
  }
};
